import { common, special } from '../../api/index';
import HandsontableWrapper from "../../components/table/Handsontable/Handsontable.vue";
import ExportTkdListFileModal from "../ExportTkdListFileModal/ExportTkdListFileModal.vue";
//import ExportTkdListFileModal from "../ExportCheckFileDuplicateModal/ExportCheckFileDuplicateModal.vue";
//import ExportTkdListFileModal from "../ExportCheckFileModal/ExportCheckFileModal.vue";
import SearchType from '../../data/constant/search-type'
import DialogType from "../../data/constant/dialog-type";
import MessageError from '../../data/constant/message-error';
const VueSimpleSuggest = require('vue-simple-suggest/dist/cjs');
import 'vue-simple-suggest/dist/styles.css'

export default {
    name: 'SpecialConfirmation',
    title: '特伝確定データ',
    components: {
        HandsontableWrapper,
        ExportTkdListFileModal,
        VueSimpleSuggest
    },
    data: function () {
        return {
            REGISTRATION_USER: SearchType.REGISTRATION_USER,
            REGISTERED_CUSTOMER: SearchType.REGISTERED_CUSTOMER,
            TANTO: SearchType.TANTO,
            MASTER: SearchType.MASTER,
            MAKER: SearchType.MAKER,
            CENTER: SearchType.CENTER,
            modalId: '',
            isSearchModalVisible: false,
            isExportModalVisible: false,
            exportSetting: {
                //fileType: '1',
                inputFlg: '1',
                yearMonthList:[],
                selecedYearMonth: '',

              },
            isDuplicateModalVisible: true,
            searchModalVal: {},
            canSearch: false,
            confirmModalVal: {},
            footerVal: {
                rightBtn: {
                    text: '確定登録',
                    type: 'success',
                },
                leftBtn: {
                    text: '特伝出力',
                    type: 'success',
                },
            },
            table: { data: [] },
            yearMonthList: [],
            registrationUserList: [],
            registrationUserName: '',
            makerList: [],
            centerList: [],
            customerList: [],
            userList: [],
            form: {
                yearMonth: '',
                registrationUserCd: '',
            },
            searchUserCd: '',
            rowCount: 0,
            tableSettings: {
                rowHeaders: true,
                colHeaders: ['登録者', '請求先', 'メーカー', '支店', 'センター', '得意先', '担当者', '未確定金額', '締め前確定金額', '締め後確定金額'],
                colWidths: [126, 126, 126, 85, 90, 126, 126, 100, 100, 100],
                cells: this.cells,
                copyPaste: {rowsLimit: 10000,},
                beforeChange: function (changes) {
                    changes.forEach((element) => {
                        const prop = element[1];
                        const newVal = element[3];
                        if (prop === 'registerTypeName' && (newVal === null || newVal === ''))
                            element[3] = element[2];
                    })
                },
            },

            registerTypeList: [],
            fileList: [],
            suggestList: [],
            lastInput: "",
            
        }
    },
    created() {
        this.$store.commit('setLoading', true);
        this.yearMonthList = this.getStorage('lastYearMonthList') || [];
        this.exportSetting.yearMonthList = this.getStorage('lastYearMonthList') || [];

        const conditionSearch = this.$store.state.conditionSearchBilling || [];
        if(conditionSearch.length > 0){
            this.form.yearMonth = conditionSearch[0].yearMonth;
            this.exportSetting.selecedYearMonth = conditionSearch[0].selecedYearMonth;
            this.form.registrationUserCd = conditionSearch[0].registrationUserCd;
            this.registrationUserName = conditionSearch[0].registrationUserName;
            this.makerList = conditionSearch[0].makerList;
            this.centerList = conditionSearch[0].centerList;
            this.customerList = conditionSearch[0].customerList;
            this.userList = conditionSearch[0].userList;
            this.registrationUserList = conditionSearch[0].registrationUserList;
        }else{
            this.form.yearMonth = this.yearMonthList.length > 0 ? this.yearMonthList[0].yearMonthCd : '';
            this.exportSetting.selecedYearMonth = this.exportSetting.yearMonthList.length > 0 ? this.exportSetting.yearMonthList[0].yearMonthCd : '';
            this.form.registrationUserCd = this.$store.state.userId;
            this.registrationUserName = this.$store.state.userName;
            this.registrationUserList = [{ 'cd': this.form.registrationUserCd, 'name': this.registrationUserName }]
        }

        this.$store.commit('setLoading', false);
    },
    beforeRouteLeave(to, form, next){
        var conditionSearch = {};
        conditionSearch['yearMonth'] = this.form.yearMonth;
        conditionSearch['selecedYearMonth'] = this.exportSetting.selecedYearMonth;
        conditionSearch['makerList'] = this.makerList;
        conditionSearch['centerList'] = this.centerList;
        conditionSearch['customerList'] = this.customerList;
        conditionSearch['userList'] = this.userList;
        conditionSearch['registrationUserCd'] = this.form.registrationUserCd;
        conditionSearch['registrationUserName'] = this.registrationUserName;
        conditionSearch['registrationUserList'] = this.registrationUserList;
        this.$store.commit('setConditionSearchBilling', [JSON.parse(JSON.stringify(conditionSearch))]);
        next();
    },
    mounted() {
        const setting = {
            columns: [
                { data: "registerUser", type: "text", className: "htLeft", readOnly: true },
                { data: "request", type: "text", className: "htLeft", readOnly: true },
                { data: "maker", type: "text", className: "htLeft", readOnly: true },
                { data: "department", type: "text", className: "htLeft", readOnly: true },
                { data: "warehouse", type: "text", className: "htLeft", readOnly: true },
                { data: "customer", type: "text", className: "htLeft", readOnly: true },
                { data: "tantoUser", type: "text", className: "htLeft", readOnly: true },
                { data: "unconfirmAmount", type: "numeric", numericFormat: { pattern: '0,0' }, readOnly: true },
                { data: "beforeClosingConfirmAmount", type: "numeric", numericFormat: { pattern: '0,0' }, readOnly: true },
                { data: "afterClosingConfirmAmount", type: "numeric", numericFormat: { pattern: '0,0' }, readOnly: true },
            ]
        };
        this.$refs.myTable.$refs.hotTable.hotInstance.updateSettings(setting, false);
    },
    methods: {
        // searchSystemUser(value) {
        //     if (!this.canSearch) {
        //         this.canSearch = true;
        //         return;
        //     }

        //     const userName = 'registrationUserName';
        //     const userList = 'registrationUserList';
        //     const userCd = 'registrationUserCd';

        //     if (!value) {
        //         this[userName] = '';
        //         this[userList] = [];
        //         return;
        //     }

        //     const request = {
        //         userCd: value,
        //         useName: ''
        //     };
        //     common.systemUser(request)
        //         .then((response) => {
        //             console.log(response);
        //             if (!this.form[userCd]) {
        //                 this[userName] = '';
        //                 this[userList] = [];
        //                 return;
        //             }
        //             this[userName] = response.data.result.userList.length > 0 ?
        //                 response.data.result.userList[0].userName : '';
        //             this[userList] = response.data.result.userList.length > 0 ?
        //                 response.data.result.userList.slice(0, 1).map(value => {
        //                     return {
        //                         cd: value.userCd,
        //                         name: value.userName
        //                     }
        //                 }) : [];

        //             this.$emit('displayErrorMessage', response);
        //         })
        //         .catch((e) => {
        //             console.log('error', e);
        //             this[userName] = '';
        //             this[userList] = [];
        //             this.$emit('displayErrorMessage', e);
        //         });
        // },
        suggestSearch(value) {
            const userName = 'registrationUserName';
            const userList = 'registrationUserList';
            const userCd = 'registrationUserCd';

            if (!value) {
                this[userName] = '';
                this[userList] = [];
                this.$refs.suggest.suggestions = [];
                return;
            }

            this.lastInput = value;

            const request = {
                userCd: value,
                useName: ''
            };
            this.registrationUserList = [];
            this.registrationUserName =  "";
            common.systemUser(request)
                .then((response) => {
                    if (!this.form[userCd]) {
                        this[userName] = '';
                        this[userList] = [];
                        this.$refs.suggest.suggestions = [];
                        return;
                    }
                    if(this.lastInput == request.userCd){
                        this.suggestList = response.data.result.userList.map(value => { return { cd: value.userCd, name: value.userName } });
                        this.$refs.suggest.suggestions = response.data.result.userList.map(value => value.userCd);
                        this.$refs.suggest.input.click();
                    }
                })
                .catch((e) => {
                    console.log('error', e);
                });
        },
        selectSuggest() {
            this.form.registrationUserCd = this.$refs.suggest.selected;
            var name = this.suggestList.filter(value =>
                value.cd === this.$refs.suggest.selected)
            this.registrationUserName = name[0].name;
            this['registrationUserList'] = this.suggestList.length > 0 ? this.suggestList.filter(value =>
                value.cd === this.$refs.suggest.selected).map(value => {
                return {
                    cd: value.cd,
                    name: value.name
                }
            }) : [];

        },
        onblur(value1){
            var name = this.suggestList.filter(value =>
                value.cd === value1)
            this.registrationUserName = name.length == 0 ? "" : name[0].name
            this['registrationUserList'] = name.length > 0 ? this.suggestList.filter(value =>
                value.cd === value1).map(value => {
                return {
                    cd: value.cd,
                    name: value.name
                }
            }) : [];
        },
        /**
        * 検索モーダル表示
        * */
        showSearchModal(modalId, isSingle) {
            this.modalId = modalId;

            this.searchModalVal.modalId = modalId;
            this.searchModalVal.isSingle = isSingle;
            switch (modalId) {
                case SearchType.CENTER:
                    this.searchModalVal.selectedItemList = this.centerList;
                    break;
                case SearchType.MAKER:
                    this.searchModalVal.selectedItemList = this.makerList;
                    break;
                case SearchType.REGISTRATION_USER:
                    this.searchModalVal.selectedItemList = this.registrationUserList;
                    break;
            }
            //検索モーダル表示
            this.isSearchModalVisible = true;
        },

        /**
         * マスタ検索モーダル表示
         * 
         */
         showMasterSearchModal(modalId, type, isSingle) {
            this.modalId = modalId;
            this.searchModalVal.type = type;
            this.searchModalVal.modalId = modalId;
            this.searchModalVal.isSingle = isSingle;

            switch (type) {
                case SearchType.REGISTERED_CUSTOMER:
                    this.searchModalVal.selectedItemList = this.customerList;
                    break;
                case SearchType.TANTO:
                    this.searchModalVal.selectedItemList = this.userList;
                    break;
            }

            //検索モーダル表示
            this.isSearchModalVisible = true;
        },

        /**
         * 検索条件追加
         * @param val
         * */
        addItem(val) {
            this.canSearch = false;
            switch (this.modalId) {
                case SearchType.REGISTRATION_USER:
                    this.registrationUserList = val;
                    this.form.registrationUserCd = this.registrationUserList.length > 0 ? this.registrationUserList[0].cd : '';
                    this.registrationUserName = this.registrationUserList.length > 0 ? this.registrationUserList[0].name : '';
                    break;
                case SearchType.MAKER:
                    this.makerList = val;
                    break;
                case SearchType.CENTER:
                    this.centerList = val;
                    break;
                case SearchType.TANTO:
                    this.userList = val;
                    break;
                case SearchType.MASTER:
                    switch(this.searchModalVal.type){
                        case SearchType.TANTO:
                            this.userList = val;
                            break;
                        case SearchType.REGISTERED_CUSTOMER:
                            this.customerList = val;
                            break;
                    }
                    break;
            }
            this.suggestList = val;
            this.$nextTick(() => this.canSearch = true);
        },

        /**
         * 検索条件クリア
         * @param value
         * */
        clear(value) {
            switch (value) {
                case SearchType.MAKER:
                    this.makerList = [];
                    break;
                case SearchType.CENTER:
                    this.centerList = [];
                    break;
                case SearchType.REGISTERED_CUSTOMER:
                    this.customerList = [];
                    break;
                case SearchType.TANTO:
                    this.userList = [];
                    break;
            }

            if (value) return;

            this.form.yearMonth = this.yearMonthList.length > 0 ? this.yearMonthList[0].yearMonthCd : '';
            this.form.registrationUserCd = this.$store.state.userId || '';
            this.registrationUserName = this.$store.state.userName || '';
            this.registrationUserList = [{ 'cd': this.form.registrationUserCd, 'name': this.registrationUserName }];
            this.makerList = [];
            this.centerList = [];
            this.customerList = [];
            this.userList = [];
        },

        search() {
            this.searchUserCd = this.form.registrationUserCd;
            this.form.requestCd = this.makerList.map(value => {
                const cdList = value.cd.split('-');
                return cdList[0]
            });
            this.form.centerList = this.centerList.map(value => {
                const cdList = value.cd.split('-');
                return {
                    departmentCd: cdList[0],
                    centerCd: cdList[1]
                }
            });
            this.form.customerList = this.customerList.map(value => {
                var cd = value.cd;
                return {
                    customerHeadCd: cd.substring(0,5),
                    customerBranchCd: cd.substring(5,8)
                }
            });
            this.form.tantoUserCd = this.userList.map(value => {
                const cdList = value.cd.split('-');
                return cdList[0]
            });
            console.log(this.form);

            if (this.form.registrationUserCd.length === 0 && this.form.requestCd.length === 0 &&
                this.form.centerList.length === 0 && this.form.customerList.length === 0 &&
                this.form.tantoUserCd.length === 0) {
                this.$emit('showSimpleModal', {
                    type: DialogType.NOTICE,
                    title: 'エラー',
                    message: '登録者、請求先、センター、得意先、担当者　' + MessageError.MASTER,
                });
                return;
            }
            this.$store.commit('setLoading', true);
            special.searchBilling(this.form)
                .then((response) => {
                    var rs = response.data.result.responseList;
                    for (let i = 0; i < response.data.result.responseList.length; i++) {
                        const element = response.data.result.responseList[i];
                        rs[i].registerUser = element.registerUserCd && element.registerUserName ? element.registerUserName : '';
                        rs[i].request = element.requestCd && element.requestName ? element.requestCd + ':' + element.requestName : '';
                        rs[i].maker = element.makerCd && element.makerName ? element.makerCd + ':' + element.makerName : '';
                        rs[i].department = element.departmentCd && element.departmentName ? element.departmentCd + ':' + element.departmentName : '';
                        rs[i].warehouse = element.warehouseCd && element.warehouseName ? element.warehouseCd + ':' + element.warehouseName : '';
                        rs[i].customer = element.customerBranchCd && element.customerHeadCd && element.customerName ? element.customerHeadCd + '' + element.customerBranchCd + ':' + element.customerName : '';
                        rs[i].tantoUser = element.tantoUserCd && element.tantoUserName ? element.tantoUserCd + ':' + element.tantoUserName : '';
                    }

                    console.log(response);
                    this.$refs.myTable.$refs.hotTable.hotInstance.loadData(rs || []);
                    this.rowCount = this.$refs.myTable.$refs.hotTable.hotInstance.countRows();

                    this.$emit('displayErrorMessage', response);
                    this.$store.commit('setLoading', false);
                })
                .catch((e) => {
                    console.log('error', e);
                    this.rowCount = 0;
                    this.$refs.myTable.$refs.hotTable.hotInstance.loadData([]);
                    this.$emit('displayErrorMessage', e);
                    this.$store.commit('setLoading', false);
                });

        },

        updateRegisterType(registerTypeCd) {
            if (!this.$refs.myTable.$refs.hotTable.hotInstance.countRows()) {
                this.$emit('showSimpleModal', {
                    type: DialogType.NOTICE,
                    title: 'Webからのメッセージ',
                    message: '検索結果がありません。'
                });
                return;
            }

            this.$emit('showConfirmModal', {
                type: DialogType.INFO,
                title: '確認',
                message: 'まとめ切り設定を一括で設定します。よろしいですか？',
                confirm: () => {
                    const registerTypeName = this.registerTypeList.find(registerType => registerType.registerTypeCd === registerTypeCd).registerTypeName;
                    const tableData = this.$refs.myTable.$refs.hotTable.hotInstance.getSourceData();
                    tableData.forEach((value) => value.registerTypeName = registerTypeName);
                    this.$refs.myTable.$refs.hotTable.hotInstance.render();
                }
            });
        },

        register() {
            var hot = this.$refs.myTable.$refs.hotTable.hotInstance;
            if (!this.$refs.myTable.$refs.hotTable.hotInstance.countRows()) {
                this.$emit('showSimpleModal', {
                    type: DialogType.NOTICE,
                    title: 'Webからのメッセージ',
                    message: '検索結果がありません。'
                });
                return;
            }
            if (!this.searchUserCd) {
                this.$emit('showSimpleModal', {
                    type: DialogType.NOTICE,
                    title: 'Webからのメッセージ',
                    message: '検索時に登録者の指定がない場合は登録できません。'
                });
                return;
            }

            this.$emit('showConfirmModal', {
                type: DialogType.NOTICE,
                title: '確認',
                message: '一覧に表示されているデータのうち、<br>登録者が'+this.$store.state.userName+'である特伝を確定します<br>確定後は修正出来ませんがよろしいですか？',
                confirm: () => {
                    this.$store.commit('setLoading', false);
                    var tableData = hot.getSourceData();
                    var registerList = []
                    tableData.forEach(value => {
                        var register = {};
                        register.registerUserCd = value.registerUserCd;
                        register.requestCd = value.requestCd;
                        register.makerCd = value.makerCd;
                        register.departmentCd = value.departmentCd;
                        register.warehouseCd = value.warehouseCd;
                        register.customerHeadCd = value.customerHeadCd;
                        register.customerBranchCd = value.customerBranchCd;
                        register.tantoUserCd = value.tantoUserCd;
                        register.updateId = value.updateId != '' ? parseInt(value.updateId) : '';
                        registerList.push(register);
                    })
                    const request = {
                        registerList: registerList
                    };
                    this.$store.commit('setLoading', true);
                    special.registHostBilling(request)
                        .then((response) => {
                            var type;
                            if (response.data.statusCd == 0){
                                type = DialogType.SUCCESS;
                            }else{
                                type = DialogType.WARNING;
                            }
                            this.$emit('showSimpleModal', {
                                type: type,
                                title: '確認',
                                message: response.data.message,
                            });
                            this.$store.commit('setLoading', false);
                        })
                        .catch((e) => {
                            console.log('error', e);
                            this.$emit('displayErrorMessage', e);
                            this.$store.commit('setLoading', false);
                        });
                    }
                }
            );
        },
        createTkdFileSetting() {

            //this.$store.commit('setLoading', true);
            this.isExportModalVisible = true;
        },

        createTkdFile() {

            this.$store.commit('setLoading', true);
            this.isExportModalVisible = false;
           //パラメータ送るのであればここ
            const request = {
                //registerList: registerList
                inputFlg:this.exportSetting.inputFlg,
                yearMonth:this.exportSetting.selecedYearMonth
            };
            
            special.createTkdFile(request)
                .then((response) => {

                    console.log('response確認', response);
                    
                    this.$emit('displayErrorMessage', response);
                    if (response.data.result.file_path) {
                        this.confirmExportStatus(response.data.result);
                    } else {
                        this.$store.commit('setLoading', false);

                    }
                })
                .catch((e) => {
                    console.log('error', e);
                    this.$emit('displayErrorMessage', e);
                    this.$store.commit('setLoading', false);
                });

        },
        confirmExportStatus(request) {
            special.confirmTkdList(request)
              .then((response) => {
                console.log('response', response);
                if (response.data.statusCd === 0) {
                  if (response.data.result.fileUrl) {
                    this.download(response.data.result.fileUrl)
                  } else {
                    setTimeout(() => this.confirmExportStatus(request), 1000);
                  }
                } else {
                  this.$emit('displayErrorMessage', response);
                  this.$store.commit('setLoading', false);
                }
              })
              .catch((e) => {
                console.log('error', e);
                this.$emit('displayErrorMessage', e);
                this.$store.commit('setLoading', false);
              })
          },
        download(fileUrl) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.click();
            this.$store.commit('setLoading', false);
        },

        cells(row, cols, prop) {
            switch (prop) {
                case 'registerTypeName':
                    {
                        const cellProperties = {};
                        cellProperties.source = this.registerTypeList.map(value => value.registerTypeName);
                        return cellProperties;
                    }
            }
        }
    },
}
